"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _actions = require('shared/actions'); var _actions2 = _interopRequireDefault(_actions);



// SAFETY: undefined is a member of the union; widening stops the call
// below from narrowing it to `undefined`.
const NO_ALERT_TYPE = undefined 

// The Super console pushes some failure alerts without a type, as the
// JavaScript did. pushAlert's typing requires one, so this passes the
// missing type through unchanged.
 const pushUntypedAlert = (title, body) =>
  // SAFETY: the alert reducer stores the type as given; undefined keeps the
  // untyped alert these screens always showed.
  _actions2.default.pushAlert(title, body, NO_ALERT_TYPE ); exports.pushUntypedAlert = pushUntypedAlert
